import App from "./App.jsx";
import "./styles.css";

export default function TankDashBoard() {
  return (
    <div className="tank_body">
      <App />
    </div>
  );
}
